import { useEffect, useMemo, useState } from 'react';
import { LineChart } from '@mui/x-charts/LineChart';
import { formatError, logError } from '../services/logging';
import { API_URL } from '../config/api';
import { toast } from 'react-toastify';

const getRootVariable = (variable) => {
    return getComputedStyle(document.documentElement).getPropertyValue(variable).trim()
}

const MoodHistory = ({ mood, subtitle, pastWeek }) => {
    const [colors, setColors] = useState({accent: '#F2726C'})
    const [moodData, setMoodData] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const accentcolor = getRootVariable('--accent-color') || '#F2726C'
        setColors({accent: accentcolor})

        const fetchMood = async () => {
            try {
                const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
                const resp = await fetch(
                    `${API_URL}/api/mood/${mood.toLowerCase()}?timezone=${encodeURIComponent(timezone)}`,
                    { method: "GET", credentials: "include" }
                )
                const data = await resp.json()
                if (resp.ok) {
                    setMoodData(data)
                } else {
                    logError(data)
                    toast.error(data.message || "Failed to fetch mood data.")
                }
            } catch (error) {
                logError(formatError(error))
                toast.error("An unexpected error occurred. Please try again.")
            } finally {
                setLoading(false)
            }
        }
        fetchMood()
    }, [mood])

    const alignedMoodData = useMemo(() => {
        const aligned = new Array(7).fill(null)
        pastWeek.forEach((date, index) => {
            const match = moodData.find(entry => 
                new Date(entry.date).toDateString() === new Date(date).toDateString()
            )
            if (match) aligned[index] = match.mood_value
        })
        return aligned
    }, [moodData, pastWeek])

    const valueFormatter = (date) =>
        date.toLocaleDateString('en-US', {
            month: 'numeric',
            day: 'numeric',
        })

    const xAxisCommon = {
        data: pastWeek,
        scaleType: 'time',
        valueFormatter,
    }

    return (
        <div className='history-item'>
            <p>{subtitle}</p>

            {loading ? (
                <section>
                    <p>Loading...</p>
                </section>
            ) : (
                <LineChart
                    xAxis={[
                        {
                            min: pastWeek[0],
                            max: pastWeek[pastWeek.length - 1],
                            ...xAxisCommon,
                            tickMinStep: 3600 * 1000 * 24,
                        }
                    ]}
                    yAxis={[
                        {
                            min: 0,
                            max: 5,
                            tickNumber: 5
                        }
                    ]}
                    series={[
                        {
                            data: alignedMoodData,
                            area: true,
                            color: colors.accent,
                        },
                    ]}
                    height={250}
                />
            )}
        </div>
    )
}

export default MoodHistory